import React from "react";
import Space from "../../commons/Space";
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import Titolo from "../../commons/Titolo";
import foto from "../../images/Nuoto/Master/DSCF9116.jpg";
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import 'bs5-lightbox';
import SpaceL from "../../commons/SpaceL";
import {Link, useNavigate} from "react-router-dom"; // Importa il componente Link da react-router-dom
import "../../styles/Master.css";
import CaroselloStandard from "../../commons/CaroselloStandard";
import TitoloColore from "../../commons/TitoloColore";
import preagonistica from "../../images/Nuoto/20240526_124354.jpg";

function GarePreAgo() {
    const navigate = useNavigate();
    return (
        <div>
            <ScrollToTopOnMount />
            <TitoloColore title={"Preagonistica"} backgroundColor={"#003F83"} />
            <FrecciaIndietro indirizzo={"/corsinuoto"} />
            <div style={{padding: "1em"}}>
                <h1 className="text-center" style={{fontFamily: "Hammersmith One", padding: "1em"}}>Risultati Gare</h1>

                <div className="text-center">
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/03%20-%2025FEB24%20TORTONA.pdf" download> 25 febbraio 2024 - Tortona</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/04%20-%2024MAR24%20TORTONA.pdf" download> 24 marzo 2024 - Tortona</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/05%20-%2021APR24%20MONZA.pdf" download> 21 aprile 2024 - Monza</a>
                    <SpaceL/>
                    <a style={{alignSelf: "end", cursor:"pointer", fontSize: "22px", fontFamily: "Hammersmith One", color: "#032041"}} href="/documents/PreAgo/06%20-%2026MAG24%20MONZA.pdf" download> 26 maggio 2024 - Monza</a>

                </div>
                <Space />

                <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                    <img src={preagonistica} style={{width: "100%"}}></img>
                </div>



            <Space />
            </div>
        </div>
    )
}

export default GarePreAgo;
